module.exports = __webpack_public_path__ + "static/3.3_ancient_mesopotamia-e4a1e4b7a618234b90706657da4e0715.pdf";